module.exports = __webpack_public_path__ + "static/media/Follo_advertiser.5242d61c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/tutorials/assets/pdfs/follo/en/Follo_advertiser.pdf
// module id = ./src/statsradio/modules/tutorials/assets/pdfs/follo/en/Follo_advertiser.pdf
// module chunks = 18